// extracted by mini-css-extract-plugin
export default {"list":"MainNav_list__P0FrH","link":"MainNav_link__bB2FK"};